import * as React from 'react';

import AppBadges from './AppBadges';
import { colors } from '../../../ui/theme';
import { CONTENT_MAX_WIDTH } from './constants';
import AspectRatio from '../../../ui/AspectRatio';

interface Props {
  contentMaxWidth?: string;
}

export default function TeamSection({
  contentMaxWidth = CONTENT_MAX_WIDTH,
}: Props) {
  return (
    <div
      className="ph5-ns ph4 pt5 pb6"
      style={{
        backgroundColor: colors.gray800,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23000000' fill-opacity='0.21' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E")`,
      }}
    >
      <h1 className="tc white f1"> The Mingl Team</h1>
      <div className="relative center" style={{ maxWidth: contentMaxWidth }}>
        <div className="pb5">
          <AspectRatio ratio="6x4">
            <div
              style={{
                height: '100%',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundImage: `url("${require('../../../../assets/img/LowRes_TeamPhoto.png')}"`,
              }}
            />
          </AspectRatio>
        </div>
        <article className="lh-copy twoColumnsSection-l fw3 pb4">
          Mingl is a Norwegian startup based in Oslo. We’re a small team of
          passionate people who want to help you organize your contacts and
          never lose them. We value our privacy and time and assume you do the
          same, that’s why we don’t sell your data or force you to watch
          annoying ads on your screen. We just want to give you a product that
          works and is as smooth as possible. <br />
          <br />
          Love from <MinglLink name="Daniel" alias="daniel" />,{' '}
          <MinglLink name="Frida" alias="frida" />,{' '}
          <MinglLink name="Sindre" alias="sindre" />,{' '}
          <MinglLink name="Michael" alias="michael" />,{' '}
          <MinglLink name="Erlend" alias="eseppola" />
          {' and '}
          <MinglLink name="Kaja" alias="kaja" />.
        </article>
        {AppBadges()}
      </div>
    </div>
  );
}

function MinglLink({ name, alias }: { name: string; alias: string }) {
  return (
    <a
      className="pointer no-underline underline-hover white"
      href={`https://www.mingl.no/${alias}`}
    >
      {name}
    </a>
  );
}
